/**
 * Loads and types the bundled game content.
 *
 * `scenarios.json` is produced by scripts/extract-scenarios.ts and validated against
 * @patc/content-schema in CI (`npm run validate:content`). Here we import it, expose it typed,
 * and derive the two structures the game machine needs: the linear play sequence and a lookup of
 * mid-task interrupt pop-ups by the scenario they fire during.
 */
import type { GameContent, PopupScenario, Scenario } from "@patc/content-schema";
import raw from "./scenarios.json";

/** The validated game content (validated at build time; cast here to the inferred type). */
export const gameContent = raw as unknown as GameContent;

/** Scenarios in play order, EXCLUDING pop-ups that fire as mid-task interrupts — those are injected
 *  into their host scenario by the game machine rather than played as their own step. */
export const playSequence: Scenario[] = gameContent.scenarios.filter(
  (s) => !(s.kind === "popup" && s.interrupt),
);

/** hostScenarioId → the interrupt pop-up that fires during it. */
export const interruptsByHost: ReadonlyMap<string, PopupScenario> = new Map(
  gameContent.scenarios
    .filter((s): s is PopupScenario => s.kind === "popup" && !!s.interrupt)
    .map((p) => [p.interrupt!.hostScenarioId, p] as const),
);
